import { useContext } from 'react';
import { MainContext, MainContextProviderProps } from './MainContextProvider';

const useMainContextProvider = (): MainContextProviderProps =>
  useContext(MainContext);

export default useMainContextProvider;
